import {gql} from "@apollo/client";

export const CANCEL_BOOKING = gql`
    mutation cancelBooking($bookingUuid: String!) {
        cancelBooking(bookingUuid: $bookingUuid)
    }
`
